import { memo, useMemo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import {
  FileItem,
  Files,
} from "@coworker/apprestructured/src/task-management/components/Files/Files";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

function FilesDemo() {
  const [name, setName] = useState("document.txt");
  const [size, setSize] = useState("12KB");
  const [nbrOfItems, setNbrOfItems] = useState("3");

  const items = useMemo<FileItem[]>(() => {
    return Array.from({ length: parseInt(nbrOfItems) || 0 }).map((_, i) => {
      return {
        name,
        size,
        onDownloadClick: () => alert(`Download file #${i + 1}`),
      };
    });
  }, [name, nbrOfItems, size]);

  return (
    <Demo>
      <Name>Files</Name>
      <Highlight>
        <FixaListView id="filesdemo" size="small">
          <Files items={items} />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaInputField
          label="name"
          type="text"
          id="filesdemo-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <FixaInputField
          label="size"
          type="text"
          id="filesdemo-size"
          value={size}
          onChange={(e) => setSize(e.target.value)}
        />
        <FixaInputField
          id="filesdemo-nbrOfItems"
          value={nbrOfItems}
          onChange={(e) => setNbrOfItems(e.target.value)}
          type="number"
          min="0"
          max="100"
          label="nbrOfItems"
        />
      </Actions>
    </Demo>
  );
}

export default memo(FilesDemo);
